<template>
	<div class="ineligible_dependent_email">
		<header-component
			:is-soon="false"
			:backRoute="true"
			img-left="/trocachip/img/setinha-left-preto.svg"
			img-right="/trocachip/img/access.png"
			class="header-component"
		/>

		<div class="page_content">
			<h2
				class="email_title"
				:class="{ 'ac-color-white': ac }"
				v-if="userHasEmail()"
				v-html="ineligibleOrDependentEmailPageMessages.title"
			></h2>
			<p
				class="email_description"
				:class="{ 'ac-color-white': ac }"
				v-if="userHasEmail()"
				v-html="ineligibleOrDependentEmailPageMessages.subTitleEmail"
			></p>
			<p
				class="email_description"
				:class="{ 'ac-color-white': ac }"
				v-if="userHasEmail()"
				v-html="ineligibleOrDependentEmailPageMessages.ineligibleDescription">
				
			</p>

			<p
				class="email_description"
				:class="{ 'ac-color-white': ac }"
				v-if="userHasEmail()"
				v-html="ineligibleOrDependentEmailPageMessages.dependentDescription">
				
			</p>
			
			<section class="email_subtitle">
				<strong
					v-if="userHasEmail()"
					v-html="ineligibleOrDependentEmailPageMessages.registeredEmail"
				></strong>
				<br />
				<label v-if="userHasEmail()">{{
					maskEmail(customer.email.toLowerCase())
				}}</label>
			</section>

			<section class="expiration_info_card">
				<div>
					<span v-html="ineligibleOrDependentEmailPageMessages.infoDescription"></span>
					<img src="/trocachip/img/notifications-info.svg"/>
				</div>
			</section>
			<div class="next_submit">
				<button
					id="submitEmail"
					class="btn_next btn_next_active"
					:class="{
						'btn_next_active': ac,
						'ac-border-yellow': ac,
						'ac-color-yellow': ac,
						'ac-bg-gray': ac,
					}"
					@click="next"
				>
					<loader-bottom v-if="loader" />
					<span v-if="!loader">Continuar</span>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import HeaderComponent from '../components/HeaderComponent.vue';
import trackEvent from '../services/trackEvent';

export default {
	name: 'IneligibleOrDependentEmail',
	components: { HeaderComponent },
	data() {
		return {
			email: '',
			errors: {},
			loader: false,
			loading: false,
		};
	},
	watch: {
		email: function () {
			if (this.email.includes('@')) {
				this.validateEmail();
			}
		},
	},
	created() {
		this.sendTracker('screen_inegibilidade_alterar_email', 3);
		console.log(this.includeEmailConfig);
	},
	computed: {
		...mapState({
			ac: (state) => state.ac,
			config: (state) => state.config,
			customer: (state) => state.customer,
			ineligibleOrDependentEmailPageMessages: (state) => state.config.ineligibleOrDependentEmail,
			finishingTitles: (state) => state.config.finishingTitles,
			enableFlagEsim: (state) => state.config.enableFlagEsim,
		}),
	},
	methods: {
		userHasEmail() {
			return this.customer.email;
		},
		cleanErrors() {
			this.errors.invalid = false;
		},
		maskEmail(email) {
			let [firstPart, ...rest] = email.split('@');
			const firstPartMiddleSize = firstPart.length / 2;
			let stringToReplace = '';

			for (let i = firstPartMiddleSize; i < firstPart.length; i++) {
				stringToReplace += '*';
			}

			firstPart = firstPart.replace(
				firstPart.substring(firstPartMiddleSize, firstPart.length),
				stringToReplace
			);

			return [...firstPart, '@', ...rest].join('');
		},
		proceed() {
			if (this.enableFlagEsim && this.$store.getters.getFlowEsim) {
				this.$router.push({
					name: 'finishingScreen',
					params: {
						title: this.finishingTitles.processingTitle,
						changeEmail: false,
					},
				});
			} else if (
				this.$store.getters.getFlowSelected == 'chipToESim' ||
				this.$store.getters.getFlowSelected == 'eSimToESim'
			) {
				this.sendTracker('email validado continuar');
				this.$router.push({ name: 'loading-page' });
			} else {
				this.$router.push({ name: 'instrucoes-barcode' });
			}
		},
		next() {
			this.sendTracker('confirmar email continuar');
			this.$router.push({
					name: 'finishingScreen',
					params: {
						title: this.finishingTitles.processingTitle,
						changeEmail: false,
					},
				});
		},
		validateEmail() {
			this.errors.invalid = !/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(this.email);
		},
		sendTracker(eventLabel, eventAction = 2) {
			trackEvent.track({
				user: {
					login: this.customer.login,
					loginType: this.customer.loginType,
					lineType: this.customer.lineType,
					segment: this.customer.segment,
					subSegment: this.customer.subSegment,
					planCode: this.customer.planCode,
					planName: this.customer.planName,
				},
				channel: trackEvent.getChannel(),
				'event-category': 6,
				'event-label': eventLabel,
				'event-location': 'mvp esim',
				'event-value': this.customer.isExOiCustomer ? 'oi' : 'tim',
				'event-status': 'Sucesso',
				'event-action': eventAction,
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.ineligible_dependent_email {
	width: 100%;
	height: 100%;
	display: block;
	position: absolute;
	z-index: -1;	
	> .page_content {
		margin: 25% 0%;
		> .email_title {
			font-family: 'timsans_thin';
			font-size: 1.5rem;
			line-height: 1.875rem;
			text-align: center;
		}
		> .email_description {
			font-family: 'timsans_regular';
			font-size: 14px;
			line-height: 21px;
			text-align: center;
			color: #696969
		}

		> .email_subtitle {
			font-family: 'timsans_regular';
			font-size: 14px;
			line-height: 21px;
			text-align: center;
			margin-top: 40px;
			margin-bottom: 40px;
			> label {
				color: #696969
			}
		}
		> .next_submit {
			margin: 60px auto 40px auto;
		}		
	}
}
.expiration_info_card {
	box-sizing: border-box;
	margin: auto;			
		> div {					
			display: flex;
			padding: 1.5rem;
			justify-content: space-between;
			background-color: #F0F1F2;
			align-items: flex-start;
			font-family: 'timsans_regular';
			font-size: 14px;
			line-height: 21x;
		}
}

</style>